// ─── ALQOS™ Auditoría y Trazabilidad ──────────────────────────
// Lee los 4 campos que el trigger de Postgres set_audit_fields() inyecta en
// `data` (creado_por, creado_en, modificado_por, modificado_en) desde Fase G
// (09/08/2026). Solo lectura — este módulo no escribe nada.
// Restringido a Administrador y Calidad (ver AuditoriaTrazabilidad en App.js
// y ROLES.Calidad.modulosVisibles en GestorUsuarios.js).
import { useState, useEffect, useCallback } from "react";
import { supabase } from "./supabase";

const Q = {
  azul:"#1C3FAA", azulVivo:"#2A7FFF", azulMedio:"#6B6FD6",
  grisClaro:"#E8E9F6", grisPalido:"#F4F6FB", grisOscuro:"#2B2F36",
  grisPlata:"#8E93A1", blanco:"#FFFFFF",
};

// Las 97 tablas con trg_audit_fields aplicado (relevadas por consulta directa
// a information_schema.triggers, no adivinadas), agrupadas por el módulo de
// la app que las usa — mismo criterio de agrupamiento que las categorías del
// menú en App.js. `campoCodigo` es solo metadata para mejorLabel() (qué
// campo mostrar como etiqueta del registro) -- "Buscar por código" NO filtra
// por campoCodigo, hace substring sobre todo `data` (ver buscarCodigo()), así
// que un campoCodigo mal asumido no hace fallar la búsqueda, solo afecta qué
// texto se muestra como label si ese campo puntual no existe en la fila.
const MODULOS_AUDITORIA = [
  // ── Calidad y Operaciones ──
  { tabla:"ots",                        nombre:"Órdenes de Trabajo",                      grupo:"Órdenes de Trabajo",  campoCodigo:"op" },
  { tabla:"ncs",                        nombre:"No Conformidades",                        grupo:"No Conformidades",    campoCodigo:"nci" },
  { tabla:"documentos",                 nombre:"Documentos",                              grupo:"Documentos",          campoCodigo:"codigo" },
  { tabla:"familias",                   nombre:"Familias y Líneas",                       grupo:"Familias y Líneas",   campoCodigo:"codigo" },
  { tabla:"fase_familia_linea",         nombre:"Familias y Líneas — Fase por familia/línea", grupo:"Familias y Líneas", campoCodigo:"codigo" },
  { tabla:"indicadores_mensuales_familia", nombre:"Familias y Líneas — Indicadores mensuales", grupo:"Familias y Líneas", campoCodigo:"codigo" },
  { tabla:"fmeas",                      nombre:"FMEA",                                    grupo:"FMEA",                campoCodigo:"idFMEA" },
  { tabla:"plancontrol",                nombre:"Plan de Control",                         grupo:"Plan de Control",     campoCodigo:"idPC" },
  { tabla:"capabilidad",                nombre:"Capabilidad y MSA",                       grupo:"Capabilidad y MSA",   campoCodigo:"codigo" },
  { tabla:"capabilidad_config",         nombre:"Capabilidad y MSA — Configuración",       grupo:"Capabilidad y MSA",   campoCodigo:"codigo" },
  { tabla:"acciones",                   nombre:"Acciones Correctivas",                    grupo:"Acciones Correctivas",campoCodigo:"codigo" },
  { tabla:"fsc_arqueo",                 nombre:"FSC Arqueo",                              grupo:"FSC Arqueo",          campoCodigo:"idMovimiento" },
  { tabla:"analisis_causa",             nombre:"Análisis de Causa",                       grupo:"Análisis de Causa",   campoCodigo:"codigo" },
  { tabla:"programa_auditorias",        nombre:"Programa de Auditorías",                  grupo:"Programa Auditorías", campoCodigo:"codigo" },
  { tabla:"conformes",                  nombre:"Assured Quality — Conformes",             grupo:"Assured Quality",     campoCodigo:"codigo" },
  { tabla:"aq_historial",               nombre:"Assured Quality — Historial",             grupo:"Assured Quality",     campoCodigo:"codigo" },
  { tabla:"aq_umbrales",                nombre:"Assured Quality — Umbrales",              grupo:"Assured Quality",     campoCodigo:"codigo" },
  { tabla:"programas_calidad_cliente",  nombre:"Assured Quality — Programas de cliente",  grupo:"Assured Quality",     campoCodigo:"codigo" },
  { tabla:"haccp",                      nombre:"HACCP",                                   grupo:"HACCP",               campoCodigo:"codigo" },
  { tabla:"poes",                       nombre:"POEs",                                    grupo:"POEs",                campoCodigo:"codigo" },
  { tabla:"cnc_config",                 nombre:"Costos de No Calidad — Configuración",    grupo:"Costos de No Calidad",campoCodigo:"codigo" },
  { tabla:"escritorio_calidad_tareas",  nombre:"Escritorio Calidad — Tareas",             grupo:"Escritorio Calidad",  campoCodigo:"codigo" },
  { tabla:"escritorio_calidad_stickers",nombre:"Escritorio Calidad — Stickers",           grupo:"Escritorio Calidad",  campoCodigo:"codigo" },
  // ── Gestión y Soporte ──
  { tabla:"auditorias",          nombre:"Auditorías",                        grupo:"Auditorías",     campoCodigo:"codigo" },
  { tabla:"checklist_templates", nombre:"Auditorías — Plantillas de checklist", grupo:"Auditorías",  campoCodigo:"codigo" },
  { tabla:"proveedores",         nombre:"Proveedores",                       grupo:"Proveedores",    campoCodigo:"codigo" },
  { tabla:"cotizaciones",        nombre:"Cotización",                        grupo:"Cotización",     campoCodigo:"codigo" },
  { tabla:"capacitaciones",      nombre:"Capacitaciones",                    grupo:"Capacitaciones", campoCodigo:"codigo" },
  { tabla:"compras",             nombre:"Compras",                           grupo:"Compras",        campoCodigo:"codigo" },
  { tabla:"empleados",           nombre:"Recursos Humanos",                  grupo:"Recursos Humanos", campoCodigo:"codigo" },
  { tabla:"perfiles_puesto",     nombre:"Recursos Humanos — Perfiles de puesto", grupo:"Recursos Humanos", campoCodigo:"codigo" },
  { tabla:"ventas",              nombre:"Ventas",                            grupo:"Ventas",         campoCodigo:"codigo" },
  { tabla:"notas_comerciales",   nombre:"Ventas — Notas comerciales",        grupo:"Ventas",         campoCodigo:"codigo" },
  { tabla:"agenda_comercial",    nombre:"Ventas — Agenda comercial",         grupo:"Ventas",         campoCodigo:"codigo" },
  { tabla:"clientes",            nombre:"Clientes",                         grupo:"Clientes",        campoCodigo:"codigo" },
  { tabla:"et_specs",            nombre:"Especificaciones Técnicas",         grupo:"Especificaciones Técnicas", campoCodigo:"codigo" },
  { tabla:"et_eliminados",       nombre:"Especificaciones Técnicas — Eliminadas", grupo:"Especificaciones Técnicas", campoCodigo:"codigo" },
  { tabla:"centros_costo",       nombre:"Centros de Costo",                  grupo:"Centros de Costo",campoCodigo:"codigo" },
  { tabla:"motor_costeo",        nombre:"Motor de Costeo",                   grupo:"Motor de Costeo", campoCodigo:"codigo" },
  // ── Recepción y Materiales ──
  { tabla:"ingreso_materiales",  nombre:"Ingreso de Materiales",             grupo:"Ingreso de Materiales", campoCodigo:"codigoIngreso" },
  { tabla:"stock_materiales",    nombre:"Stock Materiales",                  grupo:"Stock Materiales",campoCodigo:"codigo" },
  { tabla:"stock_movimientos",   nombre:"Stock Materiales — Movimientos",    grupo:"Stock Materiales",campoCodigo:"codigo" },
  { tabla:"stock_pallets",       nombre:"Stock Materiales — Pallets",        grupo:"Stock Materiales",campoCodigo:"codigo" },
  { tabla:"tipos_material",      nombre:"Stock Materiales — Tipos de material", grupo:"Stock Materiales", campoCodigo:"codigo" },
  { tabla:"config_materiales",   nombre:"Stock Materiales — Configuración",  grupo:"Stock Materiales",campoCodigo:"codigo" },
  { tabla:"trazabilidad",        nombre:"Trazabilidad",                      grupo:"Trazabilidad",   campoCodigo:"codigo" },
  // ── Procesos Productivos ──
  { tabla:"produccion",          nombre:"Producción",                        grupo:"Producción",     campoCodigo:"codigo" },
  { tabla:"preprensa",           nombre:"Pre Prensa",                        grupo:"Pre Prensa",     campoCodigo:"codigo" },
  { tabla:"preprensa_planchas",  nombre:"Pre Prensa — Planchas",             grupo:"Pre Prensa",     campoCodigo:"codigo" },
  { tabla:"oficina_tecnica",     nombre:"Oficina Técnica",                   grupo:"Oficina Técnica",campoCodigo:"codigo" },
  { tabla:"dd_proyectos",        nombre:"Diseño y Desarrollo",               grupo:"Diseño y Desarrollo", campoCodigo:"codigo" },
  { tabla:"despachos",           nombre:"Despacho",                          grupo:"Despacho",       campoCodigo:"codigo" },
  { tabla:"maquinas",            nombre:"Máquinas",                          grupo:"Máquinas",       campoCodigo:"codigo" },
  // ── Seguridad e Integridad ──
  { tabla:"hs_registros",              nombre:"Higiene y Seguridad",              grupo:"Higiene y Seguridad", campoCodigo:"codigo" },
  { tabla:"tpm",                       nombre:"TPM Mantenimiento",                grupo:"TPM Mantenimiento",   campoCodigo:"codigo" },
  { tabla:"ce_contactos",              nombre:"Comercio Exterior — Contactos",    grupo:"Comercio Exterior",   campoCodigo:"codigo" },
  { tabla:"ce_aranceles",              nombre:"Comercio Exterior — Aranceles",    grupo:"Comercio Exterior",   campoCodigo:"codigo" },
  { tabla:"ce_exportaciones",          nombre:"Comercio Exterior — Exportaciones",grupo:"Comercio Exterior",   campoCodigo:"codigo" },
  { tabla:"ce_importaciones",          nombre:"Comercio Exterior — Importaciones",grupo:"Comercio Exterior",   campoCodigo:"codigo" },
  { tabla:"ciberseg_inc",              nombre:"Ciberseguridad — Incidentes",      grupo:"Ciberseguridad",      campoCodigo:"codigo" },
  { tabla:"ciberseg_activos",          nombre:"Ciberseguridad — Activos",         grupo:"Ciberseguridad",      campoCodigo:"codigo" },
  { tabla:"ciberseg_ctrl",             nombre:"Ciberseguridad — Controles",       grupo:"Ciberseguridad",      campoCodigo:"codigo" },
  { tabla:"hs_consultor_empresas",     nombre:"ALQOS Asesor — Empresas",          grupo:"ALQOS Asesor",        campoCodigo:"codigo" },
  { tabla:"hs_consultor_visitas",      nombre:"ALQOS Asesor — Visitas",           grupo:"ALQOS Asesor",        campoCodigo:"codigo" },
  { tabla:"hs_consultor_hallazgos",    nombre:"ALQOS Asesor — Hallazgos",         grupo:"ALQOS Asesor",        campoCodigo:"codigo" },
  { tabla:"hs_consultor_tareas",       nombre:"ALQOS Asesor — Tareas",            grupo:"ALQOS Asesor",        campoCodigo:"codigo" },
  { tabla:"hs_consultor_aspectos",     nombre:"ALQOS Asesor — Aspectos",          grupo:"ALQOS Asesor",        campoCodigo:"codigo" },
  { tabla:"hs_consultor_objetivos",    nombre:"ALQOS Asesor — Objetivos",         grupo:"ALQOS Asesor",        campoCodigo:"codigo" },
  { tabla:"hs_consultor_stickers",     nombre:"ALQOS Asesor — Stickers",          grupo:"ALQOS Asesor",        campoCodigo:"codigo" },
  { tabla:"hs_programas_anuales",      nombre:"ALQOS Asesor — Programas anuales", grupo:"ALQOS Asesor",        campoCodigo:"codigo" },
  { tabla:"hs_legalmatrix_empresas",   nombre:"LegalMatrix Engine — Empresas",    grupo:"LegalMatrix Engine",  campoCodigo:"codigo" },
  { tabla:"hs_legalmatrix_resultados", nombre:"LegalMatrix Engine — Resultados",  grupo:"LegalMatrix Engine",  campoCodigo:"codigo" },
  // ── Sustentabilidad ──
  { tabla:"huella_carbono",       nombre:"Huella de Carbono",                    grupo:"Huella de Carbono",    campoCodigo:"codigo" },
  { tabla:"hc_factores_custom",   nombre:"Huella de Carbono — Factores personalizados", grupo:"Huella de Carbono", campoCodigo:"codigo" },
  { tabla:"sust_aspectos",        nombre:"Sustentabilidad — Aspectos",           grupo:"Sustentabilidad y MA", campoCodigo:"codigo" },
  { tabla:"sust_objetivos",       nombre:"Sustentabilidad — Objetivos",          grupo:"Sustentabilidad y MA", campoCodigo:"codigo" },
  { tabla:"sust_consumos",        nombre:"Sustentabilidad — Consumos",           grupo:"Sustentabilidad y MA", campoCodigo:"codigo" },
  { tabla:"sust_residuos",        nombre:"Sustentabilidad — Residuos",           grupo:"Sustentabilidad y MA", campoCodigo:"codigo" },
  { tabla:"sust_legal",           nombre:"Sustentabilidad — Legal",              grupo:"Sustentabilidad y MA", campoCodigo:"codigo" },
  { tabla:"sust_config_consumos", nombre:"Sustentabilidad — Config. consumos",   grupo:"Sustentabilidad y MA", campoCodigo:"codigo" },
  { tabla:"sust_config_residuos", nombre:"Sustentabilidad — Config. residuos",   grupo:"Sustentabilidad y MA", campoCodigo:"codigo" },
  // ── Inteligencia ──
  { tabla:"aria_historial", nombre:"ARIA — Historial",  grupo:"ARIA — IA", campoCodigo:"codigo" },
  { tabla:"feedback",       nombre:"ARIA — Feedback",   grupo:"ARIA — IA", campoCodigo:"codigo" },
  // ── Administración ──
  { tabla:"instructivos",       nombre:"Instructivos ALQOS™",             grupo:"Instructivos ALQOS™",     campoCodigo:"codigo" },
  { tabla:"cumplimiento",       nombre:"Cumplimiento de Normas",          grupo:"Cumplimiento de Normas",  campoCodigo:"codigo" },
  { tabla:"cumplimiento_normas",nombre:"Cumplimiento de Normas — Detalle",grupo:"Cumplimiento de Normas",  campoCodigo:"codigo" },
  { tabla:"comunicados",        nombre:"Comunicados Internos",            grupo:"Comunicados Internos",    campoCodigo:"codigo" },
  { tabla:"onboarding",         nombre:"Onboarding",                      grupo:"Onboarding",              campoCodigo:"codigo" },
  { tabla:"mapa_procesos",      nombre:"Mapa de Procesos ALQOS™",         grupo:"Mapa de Procesos ALQOS™", campoCodigo:"codigo" },
  { tabla:"alqos_news",         nombre:"ALQOS News",                      grupo:"ALQOS News",              campoCodigo:"codigo" },
  // ── Finanzas ──
  { tabla:"alqos_plan_cuentas",     nombre:"Plan de Cuentas",              grupo:"Plan de Cuentas",         campoCodigo:"codigo" },
  { tabla:"alqos_asientos",         nombre:"Asientos Contables",           grupo:"Asientos Contables",      campoCodigo:"codigo" },
  { tabla:"alqos_asientos_lineas",  nombre:"Asientos Contables — Líneas",  grupo:"Asientos Contables",      campoCodigo:"codigo" },
  { tabla:"alqos_cxc_cxp",          nombre:"Cuentas por Cobrar/Pagar",     grupo:"Cuentas por Cobrar/Pagar",campoCodigo:"codigo" },
  { tabla:"alqos_movimientos_caja", nombre:"Movimientos de Caja",          grupo:"Movimientos de Caja",     campoCodigo:"codigo" },
  { tabla:"finanzas_config",        nombre:"Finanzas — Configuración",     grupo:"Finanzas",                campoCodigo:"codigo" },
  // ── Otros / Sistema ──
  { tabla:"notificaciones", nombre:"Notificaciones (sistema)", grupo:"Otros", campoCodigo:"codigo" },
];

// Agrupa MODULOS_AUDITORIA por `grupo` preservando el orden de aparición,
// para renderizar <optgroup> en el selector de la pestaña Bitácora.
function agruparPorModulo(lista) {
  const grupos = [];
  const indice = {};
  lista.forEach(m => {
    if (!(m.grupo in indice)) { indice[m.grupo] = grupos.length; grupos.push({ grupo:m.grupo, items:[] }); }
    grupos[indice[m.grupo]].items.push(m);
  });
  return grupos;
}
const GRUPOS_AUDITORIA = agruparPorModulo(MODULOS_AUDITORIA);

function formatFecha(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("es-AR", { day:"2-digit", month:"2-digit", year:"numeric", hour:"2-digit", minute:"2-digit" });
  } catch { return iso; }
}

function mejorLabel(row, modulo) {
  const d = row.data || {};
  return d[modulo.campoCodigo] || d.codigo || d.titulo || d.nombre || `#${row.id}`;
}

export default function AuditoriaTrazabilidad({ onVolver, oscuro, usuario }) {
  const acceso = usuario?.rol === "Administrador" || usuario?.rol === "Calidad";

  const [tab, setTab] = useState("buscar");
  const [usuarios, setUsuarios] = useState([]);

  // ── Buscar por código ──
  const [codigoInput, setCodigoInput] = useState("");
  const [buscando, setBuscando] = useState(false);
  const [resultado, setResultado] = useState(null); // { row, modulo } | "no_encontrado" | null

  // ── Bitácora por módulo ──
  const [moduloSel, setModuloSel] = useState(MODULOS_AUDITORIA[0].tabla);
  const [usuarioFiltro, setUsuarioFiltro] = useState("");
  const [desde, setDesde] = useState("");
  const [hasta, setHasta] = useState("");
  const [cargandoBitacora, setCargandoBitacora] = useState(false);
  const [eventos, setEventos] = useState(null);

  useEffect(() => {
    if (!acceso || !usuario?.tenant_id) return;
    supabase.from("usuarios").select("id,nombre,rol").eq("tenant_id", usuario.tenant_id)
      .then(({ data, error }) => { if (!error && data) setUsuarios(data); });
  }, [acceso, usuario?.tenant_id]);

  const usuariosMap = {};
  usuarios.forEach(u => { usuariosMap[u.id] = u; });
  const resolverUsuario = (id) => {
    if (!id) return "—";
    const u = usuariosMap[id];
    return u ? `${u.nombre} (${u.rol})` : `Usuario #${id}`;
  };

  const buscarCodigo = async () => {
    const codigo = codigoInput.trim();
    if (!codigo || !usuario?.tenant_id) return;
    setBuscando(true);
    setResultado(null);
    try {
      // Substring case-insensitive sobre todo `data` (equivalente a
      // data::text ilike '%codigo%'), no sobre un campo puntual -- así no
      // depende de acertar el nombre de campo real de cada una de las 97
      // tablas. campoCodigo queda solo como metadata para mejorLabel().
      const codigoLower = codigo.toLowerCase();
      const busquedas = MODULOS_AUDITORIA.map(async (modulo) => {
        const { data, error } = await supabase.from(modulo.tabla)
          .select("id,data")
          .eq("tenant_id", usuario.tenant_id);
        if (error || !data?.length) return null;
        const match = data.find(row => JSON.stringify(row.data || {}).toLowerCase().includes(codigoLower));
        return match ? { row: match, modulo } : null;
      });
      const encontrados = (await Promise.all(busquedas)).filter(Boolean);
      setResultado(encontrados[0] || "no_encontrado");
    } catch (e) {
      console.error("buscarCodigo:", e);
      setResultado("no_encontrado");
    } finally {
      setBuscando(false);
    }
  };

  const cargarBitacora = useCallback(async () => {
    if (!usuario?.tenant_id) return;
    setCargandoBitacora(true);
    setEventos(null);
    try {
      const modulo = MODULOS_AUDITORIA.find(m => m.tabla === moduloSel);
      const { data, error } = await supabase.from(moduloSel).select("id,data").eq("tenant_id", usuario.tenant_id);
      if (error) { console.error("cargarBitacora:", error); setEventos([]); return; }

      let ev = [];
      (data || []).forEach(row => {
        const d = row.data || {};
        const label = mejorLabel(row, modulo);
        if (d.creado_en) ev.push({ id:row.id, tipo:"alta", fecha:d.creado_en, usuarioId:d.creado_por, label });
        if (d.modificado_en && d.modificado_en !== d.creado_en) {
          ev.push({ id:row.id, tipo:"modificacion", fecha:d.modificado_en, usuarioId:d.modificado_por, label });
        }
      });

      if (usuarioFiltro) ev = ev.filter(e => String(e.usuarioId) === String(usuarioFiltro));
      if (desde) ev = ev.filter(e => e.fecha >= desde);
      if (hasta) ev = ev.filter(e => e.fecha <= hasta + "T23:59:59");

      ev.sort((a, b) => (a.fecha < b.fecha ? 1 : -1));
      setEventos(ev);
    } catch (e) {
      console.error("cargarBitacora:", e);
      setEventos([]);
    } finally {
      setCargandoBitacora(false);
    }
  }, [moduloSel, usuarioFiltro, desde, hasta, usuario?.tenant_id]);

  const bg      = oscuro ? "#09184D" : Q.grisPalido;
  const cardBg  = oscuro ? "#0d2160" : Q.blanco;
  const texto   = oscuro ? "#EDF2FA" : Q.grisOscuro;
  const borde   = oscuro ? "#1e3a8a" : Q.grisClaro;
  const navBg   = oscuro ? "#060f30" : Q.azul;
  const subtexto= oscuro ? "#9aabd4" : Q.grisPlata;

  const inp = {width:"100%",padding:"9px 12px",borderRadius:"10px",border:`1.5px solid ${borde}`,fontSize:"13px",boxSizing:"border-box",background:cardBg,color:texto,fontFamily:"sans-serif",outline:"none"};
  const lbl = {fontSize:"11px",color:subtexto,fontWeight:"700",display:"block",marginBottom:"4px",letterSpacing:".05em",textTransform:"uppercase"};
  const card = {background:cardBg,borderRadius:"14px",padding:"1.5rem",border:`1px solid ${borde}`,marginBottom:"14px"};

  const Header = () => (
    <div style={{background:navBg,padding:"1rem 1.5rem",display:"flex",alignItems:"center",gap:"12px",position:"sticky",top:0,zIndex:100,marginBottom:"1.5rem",boxShadow:`0 2px 12px ${Q.azul}40`}}>
      <button onClick={onVolver} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"white",padding:"6px 14px",borderRadius:"10px",cursor:"pointer",fontSize:"13px"}}>← Volver</button>
      <span style={{color:"white",fontWeight:"700",fontSize:"16px"}}>🕵️ Auditoría y Trazabilidad</span>
    </div>
  );

  if (!acceso) return (
    <div style={{minHeight:"100vh",background:bg,fontFamily:"sans-serif"}}>
      <Header/>
      <div style={{padding:"0 2rem",maxWidth:"600px",margin:"0 auto"}}>
        <div style={{...card,textAlign:"center"}}>
          <p style={{fontSize:"32px",margin:"0 0 8px"}}>🔒</p>
          <p style={{fontSize:"14px",color:texto,fontWeight:"600"}}>Acceso restringido</p>
          <p style={{fontSize:"13px",color:subtexto}}>Este módulo es solo para Administrador y Calidad.</p>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh",background:bg,fontFamily:"sans-serif"}}>
      <Header/>
      <div style={{padding:"0 2rem 3rem",maxWidth:"900px",margin:"0 auto"}}>

        <div style={{display:"flex",gap:"6px",marginBottom:"1.2rem",background:cardBg,borderRadius:"12px",padding:"6px",border:`1px solid ${borde}`}}>
          {[["buscar","🔎 Buscar por código"],["bitacora","📖 Bitácora por módulo"]].map(([id,label])=>(
            <button key={id} onClick={() => setTab(id)}
              style={{flex:1,padding:"8px",borderRadius:"8px",border:"none",cursor:"pointer",fontSize:"12px",fontWeight:"700",background:tab===id?`linear-gradient(135deg,${Q.azulVivo},${Q.azul})`:"transparent",color:tab===id?"white":subtexto,transition:"all 0.2s"}}>
              {label}
            </button>
          ))}
        </div>

        {tab === "buscar" && (
          <div>
            <div style={card}>
              <label style={lbl}>Código del registro (ej: NCI-2026-0041, OC-2026-0012, AUD-2026-003)</label>
              <div style={{display:"flex",gap:"8px",marginTop:"4px"}}>
                <input value={codigoInput} onChange={e=>setCodigoInput(e.target.value)}
                  onKeyDown={e => { if (e.key === "Enter") buscarCodigo(); }}
                  placeholder="Pegá o escribí el código..." style={inp}/>
                <button onClick={buscarCodigo} disabled={buscando || !codigoInput.trim()}
                  style={{padding:"9px 20px",background:Q.azulVivo,color:"white",border:"none",borderRadius:"10px",cursor:buscando?"default":"pointer",fontSize:"13px",fontWeight:"600",opacity:buscando||!codigoInput.trim()?0.6:1,whiteSpace:"nowrap"}}>
                  {buscando ? "Buscando..." : "Buscar"}
                </button>
              </div>
              <p style={{fontSize:"11px",color:subtexto,marginTop:"8px",marginBottom:0}}>
                Busca en las {MODULOS_AUDITORIA.length} tablas relevadas (con trg_audit_fields aplicado) — ver el listado completo agrupado por módulo en la pestaña "Bitácora por módulo".
              </p>
            </div>

            {resultado === "no_encontrado" && (
              <div style={{...card,textAlign:"center"}}>
                <p style={{fontSize:"28px",margin:"0 0 8px"}}>🤷</p>
                <p style={{fontSize:"13px",color:texto}}>No se encontró ningún registro con ese código en los módulos relevados.</p>
              </div>
            )}

            {resultado && resultado !== "no_encontrado" && (
              <div style={card}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"14px"}}>
                  <span style={{fontSize:"15px",fontWeight:"800",color:Q.azulVivo}}>{mejorLabel(resultado.row, resultado.modulo)}</span>
                  <span style={{fontSize:"11px",color:subtexto,background:`${Q.azulVivo}12`,padding:"3px 10px",borderRadius:"8px"}}>{resultado.modulo.nombre}</span>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"12px"}}>
                  <div>
                    <span style={lbl}>Creado por</span>
                    <p style={{fontSize:"13px",color:texto,margin:0}}>{resolverUsuario(resultado.row.data?.creado_por)}</p>
                  </div>
                  <div>
                    <span style={lbl}>Creado el</span>
                    <p style={{fontSize:"13px",color:texto,margin:0}}>{formatFecha(resultado.row.data?.creado_en)}</p>
                  </div>
                  <div>
                    <span style={lbl}>Última modificación por</span>
                    <p style={{fontSize:"13px",color:texto,margin:0}}>{resolverUsuario(resultado.row.data?.modificado_por)}</p>
                  </div>
                  <div>
                    <span style={lbl}>Modificado el</span>
                    <p style={{fontSize:"13px",color:texto,margin:0}}>{formatFecha(resultado.row.data?.modificado_en)}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {tab === "bitacora" && (
          <div>
            <div style={card}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"12px",marginBottom:"12px"}}>
                <div>
                  <label style={lbl}>Módulo</label>
                  <select value={moduloSel} onChange={e=>setModuloSel(e.target.value)} style={inp}>
                    {GRUPOS_AUDITORIA.map(g => (
                      <optgroup key={g.grupo} label={g.grupo}>
                        {g.items.map(m => <option key={m.tabla} value={m.tabla}>{m.nombre}</option>)}
                      </optgroup>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={lbl}>Usuario</label>
                  <select value={usuarioFiltro} onChange={e=>setUsuarioFiltro(e.target.value)} style={inp}>
                    <option value="">Todos</option>
                    {usuarios.map(u => <option key={u.id} value={u.id}>{u.nombre} ({u.rol})</option>)}
                  </select>
                </div>
                <div>
                  <label style={lbl}>Desde</label>
                  <input type="date" value={desde} onChange={e=>setDesde(e.target.value)} style={inp}/>
                </div>
                <div>
                  <label style={lbl}>Hasta</label>
                  <input type="date" value={hasta} onChange={e=>setHasta(e.target.value)} style={inp}/>
                </div>
              </div>
              <button onClick={cargarBitacora} disabled={cargandoBitacora}
                style={{padding:"9px 20px",background:Q.azulVivo,color:"white",border:"none",borderRadius:"10px",cursor:cargandoBitacora?"default":"pointer",fontSize:"13px",fontWeight:"600",opacity:cargandoBitacora?0.6:1}}>
                {cargandoBitacora ? "Cargando..." : "Cargar bitácora"}
              </button>
            </div>

            {eventos && eventos.length === 0 && (
              <div style={{...card,textAlign:"center"}}>
                <p style={{fontSize:"13px",color:texto}}>Sin eventos para ese módulo con los filtros elegidos.</p>
              </div>
            )}

            {eventos && eventos.length > 0 && (
              <div style={{...card,padding:0,overflow:"hidden"}}>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:"12.5px"}}>
                    <thead>
                      <tr style={{background:oscuro?"#0a1a4c":Q.grisPalido}}>
                        {["Fecha","Evento","Registro","Usuario"].map(h => (
                          <th key={h} style={{textAlign:"left",padding:"10px 14px",color:subtexto,fontWeight:"700",fontSize:"10.5px",textTransform:"uppercase",letterSpacing:".05em"}}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {eventos.map((e, i) => (
                        <tr key={`${e.id}-${e.tipo}-${i}`} style={{borderTop:`1px solid ${borde}`}}>
                          <td style={{padding:"9px 14px",color:texto,whiteSpace:"nowrap"}}>{formatFecha(e.fecha)}</td>
                          <td style={{padding:"9px 14px"}}>
                            <span style={{fontSize:"11px",fontWeight:"700",color:e.tipo==="alta"?"#22c55e":"#f59e0b"}}>
                              {e.tipo==="alta" ? "🟢 Alta" : "🔵 Modificación"}
                            </span>
                          </td>
                          <td style={{padding:"9px 14px",color:texto,fontWeight:"600"}}>{e.label}</td>
                          <td style={{padding:"9px 14px",color:texto}}>{resolverUsuario(e.usuarioId)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
